import React from 'react';
import { Button } from 'mj-design';

export default () => (
  <Button />
);
